"use client";

import React, { useEffect, useState, useRef } from 'react'

import countAll from "./countAll";

import numeral from "numeral";

export default function UsageLine() {

    const [count, setCount] = useState();
    const [isVisible, setIsVisible] = useState(false);
    const [hasError, setHasError] = useState(false);
    const componentRef = useRef(null);

    async function loadCount() {
        if (hasError) return; // 如果已出错，不再请求
        
        try {
            const r = await countAll();
            setCount(r);
        } catch (error) {
            // 如果是 Server Action 版本不匹配错误，停止轮询
            console.warn("UsageLine loadCount error::", error?.message || error);
            setHasError(true);
        }
    }


    useEffect(() => {
        // 创建可见性检测
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.1 }
        );
        
        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => {
            if (componentRef.current) {
                observer.unobserve(componentRef.current);
            }
        };
    }, []);

    useEffect(() => {
        let intervalId;
        
        if (isVisible && !hasError) {
            loadCount();
            intervalId = setInterval(() => {
                loadCount();
            }, 3000);
        }
        
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        }
    }, [isVisible, hasError]);

    if(count === undefined) {
        return (
            <div ref={componentRef} className="h-[27px] w-[166.1px] pt-1 pb-0.5">
                <div className="h-full w-full bg-[--lc-color-bg-hover]"></div>
            </div>
        )
    }

    return (
        <div ref={componentRef}>已翻译 <span className="font-medium text-[var(--violet-11)] text-[18px]">{count ? numeral(count).format("0,0") : "--" }</span> 份文档</div>
    )
}
